import React, { Fragment } from "react";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import { Disclosure, Popover, Transition } from "@headlessui/react";
import GiftBasketMonthSelectionComponent from "./GiftBasketMonthSelectionComponent";
import { MdOutlineArrowDropDown } from "react-icons/md";
import RemoveItemConfirmationPopover from "../../RemoveItemConfirmationPopover";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import { HiPlus } from "react-icons/hi";


const GiftCartCheckout = ({
    handleViewReceipient,
    customGiftBasket,
    countGiftCustom,
    setCountGiftCustom,
    giftCustomIsRecurring,
    giftCustomIsInfinite,
    calculateTotalBasket,
    removeCustomGiftBasket,
    handleDelete,
    handleViewFoodBasketReceipient,
    customGiftFoodBasket,
    countGiftFb,
    setCountGiftFb,
    giftFoodBasketIsInfinite,
    giftFoodBasketIsRecurring,
    removeCustomGiftFoodBasket,
    setOpenGiftItemModal,
    setBasketType
}) => {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col">
            <div className='mt-8 md:mt-6 '>
                <div className='flex flex-col @sm:flex-row @sm:items-center @sm:justify-between'>
                    <h2 className='text-2xl font-bold text-gray-700'>Gift Basket</h2>
                    <div className='mt-3 @sm:mt-0 flex flex-row items-center justify-end space-x-2 @sm:justify-normal'>
                        <button onClick={() => setOpenGiftItemModal(true)} className='px-3 py-2 rounded-full bg-[#E7EBE3] text-sm font-medium text-[#558223] flex items-center space-x-1 border-[1px] border-gray-300 hover:bg-[#E7EBE3]/60'>
                            <HiPlus className='h-4 w-4' /> <span>Add another Item</span>
                        </button>
                    </div>
                </div>
                {customGiftFoodBasket && customGiftFoodBasket?.line_items?.length ? (
                    <div className='flex flex-col'>
                        <div className='mt-4 @sm:mt-6'>
                            <div className='flex items-center justify-between'>
                                <h3 className='text-base font-semibold text-gray-700'>Food Baskets</h3>
                                <div className='flex justify-between'>
                                    <button onClick={() => navigate(`/basket/gift-my-food-basket`)} className='mr-4 group flex flex-row items-center border-b-[1.5px] border-b-transparent hover:border-b-[#558223]'>
                                        <span className='text-sm font-medium text-[#558223] group-hover:text-[#558223]/80'>Edit</span>
                                        <BiEditAlt className='ml-[2px] h-3.5 w-3.5 text-[#558223]' />
                                    </button>

                                    <div>
                                        <Popover>
                                            {({ open }) => (
                                                <>
                                                    <Popover.Button
                                                        className={`
                                                                                                                            ${open ? "" : "text-opacity-90"}
                                                                                                                            focus:text-olivine-700 focus:outline-none`}
                                                    >
                                                        <button className='group h-8 w-8 rounded-full bg-[#F9D9D9] flex items-center justify-center flex-shrink-0 cursor-pointer hover:bg-[#F9D9D9]/50' >
                                                            <RiDeleteBin5Fill className='h-4 w-4 text-[#E81414] group-hover:text-[#E81414]/80' />
                                                        </button>
                                                    </Popover.Button>
                                                    <Popover.Overlay className="fixed inset-0 bg-black opacity-30" />
                                                    <Transition
                                                        as={Fragment}
                                                        enter="transition ease-out duration-200"
                                                        enterFrom="opacity-0 translate-y-1"
                                                        enterTo="opacity-100 translate-y-0"
                                                        leave="transition ease-in duration-150"
                                                        leaveFrom="opacity-100 translate-y-0"
                                                        leaveTo="opacity-0 translate-y-1"
                                                    >
                                                        <Popover.Panel className="absolute inset-x-0 top-40 z-30 mx-auto max-w-md px-2 xsm:px-4">
                                                            {({ close }) => (
                                                                <div>
                                                                    <RemoveItemConfirmationPopover
                                                                        closer={close}
                                                                        deleter={handleDelete}
                                                                        customBasket
                                                                        clear={removeCustomGiftFoodBasket}
                                                                    />
                                                                </div>
                                                            )}
                                                        </Popover.Panel>
                                                    </Transition>
                                                </>
                                            )}
                                        </Popover>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full'>
                                <Disclosure>
                                    {({ open }) => (
                                        <>
                                            <div className='mt-1 flex flex-row justify-between'>
                                                <div className='mt-[2px] flex flex-col @lg:flex-row @lg:items-center @lg:space-x-3'>
                                                    <div className='text-sm text-gray-500 font-medium'>Monthly subscription</div>
                                                    <div className='flex flex-row items-center space-x-3'>
                                                        <div className='text-lg font-semibold text-gray-700'>
                                                            {<CurrencyFormat
                                                                value={Number.parseFloat(calculateTotalBasket(customGiftFoodBasket))?.toFixed(2)}
                                                                displayType={"text"}
                                                                thousandSeparator={true}
                                                                prefix={"₦"}
                                                            />}
                                                        </div>
                                                        <Disclosure.Button className="">
                                                            <div className='flex flex-row items-center'>
                                                                <div className='text-[11px] font-medium text-gray-600'>
                                                                    See details
                                                                </div>
                                                                <MdOutlineArrowDropDown
                                                                    className={`${open ? 'rotate-180 transform' : ''
                                                                        } h-4 w-4 text-gray-600`}
                                                                />
                                                            </div>
                                                        </Disclosure.Button>
                                                    </div>
                                                </div>
                                                <div className=''>
                                                    {/* <GiftBasketMonthSelectionComponent /> */}
                                                    {giftFoodBasketIsRecurring === "yes" ? (
                                                        giftFoodBasketIsInfinite === "yes" ? (
                                                            <div className='text-[11px] font-medium text-gray-600'>
                                                                Recurring Infinitely
                                                            </div>
                                                        ) : (
                                                            <div className=''>
                                                                <GiftBasketMonthSelectionComponent count={countGiftFb} setCount={setCountGiftFb} />
                                                            </div>
                                                        )
                                                    ) : null}
                                                </div>
                                            </div>
                                            <Disclosure.Panel className="mt-2 sm:mt-1 px-4 py-3 w-full max-w-sm text-sm bg-[#DFDFDF] rounded-md">
                                                {customGiftFoodBasket?.line_items?.length &&
                                                    customGiftFoodBasket?.line_items?.map((product, idx) => (
                                                        <>
                                                            <span key={idx}>{product?.name}, </span>
                                                            <div className="mt-0.5   text-gray-600">
                                                                Quantity : {product?.quantity}
                                                            </div>
                                                            <div className="mt-0.5   text-gray-600">
                                                                Rate :
                                                                <CurrencyFormat
                                                                    value={Number.parseFloat(product?.rate)?.toFixed(2)}
                                                                    displayType={"text"}
                                                                    thousandSeparator={true}
                                                                    prefix={"₦"}
                                                                />
                                                            </div>
                                                            <div className="mt-0.5 text-gray-600 mb-4">
                                                                Total :{" "}
                                                                <CurrencyFormat
                                                                    // className={"font-bold "}
                                                                    value={Number.parseFloat(
                                                                        product?.quantity * product?.rate
                                                                    )?.toFixed(2)}
                                                                    displayType={"text"}
                                                                    thousandSeparator={true}
                                                                    prefix={"₦"}
                                                                />
                                                            </div>
                                                        </>
                                                    ))}
                                            </Disclosure.Panel>
                                        </>
                                    )}
                                </Disclosure>
                            </div>
                        </div>
                        <div className='mt-5 w-full flex flex-col @sm:flex-row @sm:items-center @sm:space-x-4'>
                            <button onClick={() => navigate("/gift-a-plan")} className='w-full @sm:w-fit px-4 py-3 rounded-md bg-[#E7EBE3] text-xs font-medium text-[#558223] flex items-center justify-center space-x-1 border-[1.5px] border-[#558223] hover:bg-[#E7EBE3]/60 hover:border-[#558223]/70'>
                                <FiPlus className='h-3.5 w-3.5' /> <span>Add to this Basket</span>
                            </button>
                            <button onClick={() => {handleViewFoodBasketReceipient(); setBasketType("giftFoodBasket");}} className='mt-4 @sm:mt-0 px-4 py-3 rounded-md bg-white text-xs font-medium text-gray-600 border-[1.5px] border-gray-500 border-dashed hover:border-gray-500/70'>
                                View Recipient’s details
                            </button>
                        </div>
                    </div>

                ) : null}

                {customGiftBasket && customGiftBasket?.line_items?.length ? (
                    <div className='flex flex-col'>
                        <div className='mt-6'>
                            <div className='flex items-center justify-between'>
                                <h3 className='text-base font-semibold text-gray-700'>Custom Basket</h3>
                                <div className='flex justify-between'>
                                    <button onClick={() => navigate("/basket/gift-my-basket")} className='mr-4 group flex flex-row items-center border-b-[1.5px] border-b-transparent hover:border-b-[#558223]'>
                                        <span className='text-sm font-medium text-[#558223] group-hover:text-[#558223]/80'>Edit</span>
                                        <BiEditAlt className='ml-[2px] h-3.5 w-3.5 text-[#558223]' />
                                    </button>

                                    <div>
                                        <Popover>
                                            {({ open }) => (
                                                <>
                                                    <Popover.Button
                                                        className={`
                                                                                                                            ${open ? "" : "text-opacity-90"}
                                                                                                                            focus:text-olivine-700 focus:outline-none`}
                                                    >
                                                        <button className='group h-8 w-8 rounded-full bg-[#F9D9D9] flex items-center justify-center flex-shrink-0 cursor-pointer hover:bg-[#F9D9D9]/50' >
                                                            <RiDeleteBin5Fill className='h-4 w-4 text-[#E81414] group-hover:text-[#E81414]/80' />
                                                        </button>
                                                    </Popover.Button>
                                                    <Popover.Overlay className="fixed inset-0 bg-black opacity-30" />
                                                    <Transition
                                                        as={Fragment}
                                                        enter="transition ease-out duration-200"
                                                        enterFrom="opacity-0 translate-y-1"
                                                        enterTo="opacity-100 translate-y-0"
                                                        leave="transition ease-in duration-150"
                                                        leaveFrom="opacity-100 translate-y-0"
                                                        leaveTo="opacity-0 translate-y-1"
                                                    >
                                                        <Popover.Panel className="absolute inset-x-0 top-40 z-30 mx-auto max-w-md px-2 xsm:px-4">
                                                            {({ close }) => (
                                                                <div>
                                                                    <RemoveItemConfirmationPopover
                                                                        closer={close}
                                                                        deleter={handleDelete}
                                                                        customBasket
                                                                        clear={removeCustomGiftBasket}
                                                                    />
                                                                </div>
                                                            )}
                                                        </Popover.Panel>
                                                    </Transition>
                                                </>
                                            )}
                                        </Popover>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full'>
                                <Disclosure>
                                    {({ open }) => (
                                        <>
                                            <div className='mt-1 flex flex-row justify-between'>
                                                <div className='mt-[2px] flex flex-col @lg:flex-row @lg:items-center @lg:space-x-3'>
                                                    <div className='text-sm text-gray-500 font-medium'>Monthly subscription</div>
                                                    <div className='flex flex-row items-center space-x-3'>
                                                        <div className='text-lg font-semibold text-gray-700'>
                                                            {<CurrencyFormat
                                                                value={Number.parseFloat(calculateTotalBasket(customGiftBasket))?.toFixed(2)}
                                                                displayType={"text"}
                                                                thousandSeparator={true}
                                                                prefix={"₦"}
                                                            />}
                                                        </div>
                                                        <Disclosure.Button className="">
                                                            <div className='flex flex-row items-center'>
                                                                <div className='text-[11px] font-medium text-gray-600'>
                                                                    See details
                                                                </div>
                                                                <MdOutlineArrowDropDown
                                                                    className={`${open ? 'rotate-180 transform' : ''
                                                                        } h-4 w-4 text-gray-600`}
                                                                />
                                                            </div>
                                                        </Disclosure.Button>
                                                    </div>
                                                </div>
                                                <div className=''>
                                                    {/* <GiftBasketMonthSelectionComponent /> */}
                                                    {giftCustomIsRecurring === "yes" ? (
                                                        giftCustomIsInfinite === "yes" ? (
                                                            <div className='text-[11px] font-medium text-gray-600'>
                                                                Recurring Infinitely
                                                            </div>
                                                        ) : (
                                                            <div className=''>
                                                                <GiftBasketMonthSelectionComponent count={countGiftCustom} setCount={setCountGiftCustom} />
                                                            </div>
                                                        )
                                                    ) : null}
                                                </div>
                                            </div>
                                            <Disclosure.Panel className="mt-2 sm:mt-1 px-4 py-3 w-full max-w-sm text-sm bg-[#DFDFDF] rounded-md">

                                                {customGiftBasket?.line_items?.length &&
                                                    customGiftBasket?.line_items?.map((product, idx) => (
                                                        <>
                                                            <span key={idx}>{product?.name}, </span>
                                                            <div className="mt-0.5   text-gray-600">
                                                                Quantity : {product?.quantity}
                                                            </div>
                                                            <div className="mt-0.5   text-gray-600">
                                                                Rate :
                                                                <CurrencyFormat
                                                                    value={Number.parseFloat(product?.rate)?.toFixed(2)}
                                                                    displayType={"text"}
                                                                    thousandSeparator={true}
                                                                    prefix={"₦"}
                                                                />
                                                            </div>
                                                            <div className="mt-0.5 text-gray-600 mb-4">
                                                                Total :{" "}
                                                                <CurrencyFormat
                                                                    // className={"font-bold "}
                                                                    value={Number.parseFloat(
                                                                        product?.quantity * product?.rate
                                                                    )?.toFixed(2)}
                                                                    displayType={"text"}
                                                                    thousandSeparator={true}
                                                                    prefix={"₦"}
                                                                />
                                                            </div>
                                                        </>
                                                    ))}
                                            </Disclosure.Panel>
                                        </>
                                    )}
                                </Disclosure>
                            </div>
                        </div>
                        <div className='mt-5 w-full flex flex-col @sm:flex-row @sm:items-center @sm:space-x-4'>
                            <button onClick={() => navigate("/gift-a-basket")} className='w-full @sm:w-fit px-4 py-3 rounded-md bg-[#E7EBE3] text-xs font-medium text-[#558223] flex items-center justify-center space-x-1 border-[1.5px] border-[#558223] hover:bg-[#E7EBE3]/60 hover:border-[#558223]/70'>
                                <FiPlus className='h-3.5 w-3.5' /> <span>Add to this Basket</span>
                            </button>
                            <button onClick={() => {handleViewReceipient();  setBasketType("giftCustomBasket");}} className='mt-4 @sm:mt-0 px-4 py-3 rounded-md bg-white text-xs font-medium text-gray-600 border-[1.5px] border-gray-500 border-dashed hover:border-gray-500/70'>
                                View Recipient’s details
                            </button>
                        </div>
                    </div>

                ) : null}
            </div>
            <div className='my-8 h-[1.5px] w-full bg-[#DFDFDF]' />
        </div>
    )
}

export default GiftCartCheckout;